import { render, staticRenderFns } from "./TagsPanel.vue?vue&type=template&id=1f799d8e&scoped=true"
import script from "./TagsPanel.vue?vue&type=script&lang=js"
export * from "./TagsPanel.vue?vue&type=script&lang=js"
import style0 from "./TagsPanel.vue?vue&type=style&index=0&id=1f799d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f799d8e",
  null
  
)

export default component.exports